import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { Offline, Online } from 'react-detect-offline';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { Box, CssBaseline, Alert, Snackbar, Button, useMediaQuery } from '@mui/material';

// project imports
import { CurrencyProvider } from 'context/Currency';
import Breadcrumbs from 'ui-component/extended/Breadcrumbs';
import Sidebar from 'views/basis/Sidebar';
import Customization from '../Customization';
import navigation from 'menu-items';
import { drawerWidth } from 'store/constant';
import { SET_MENU } from 'store/actions';
import SnackAlert from 'views/utilities/SnackAlert';
import { ApiUrl } from 'utils/Constants';
import Social from 'views/contact/social';

// assets
import { IconChevronRight, IconMenu2 } from '@tabler/icons-react';

// styles
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
    ...theme.typography.mainContent,
    ...(!open && {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        minHeight: '100vh',
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.up('md')]: {
            marginRight: 0,
            width: `calc(100% - ${drawerWidth}px)`
        },
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px',
            width: `calc(100% - ${drawerWidth}px)`,
            padding: '16px 20px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px',
            width: `calc(100% - ${drawerWidth}px)`,
            padding: '16px 20px',
            marginRight: '10px'
        }
    }),
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        marginRight: drawerWidth,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        width: `calc(100% - ${drawerWidth}px)`,
        [theme.breakpoints.down('md')]: {
            marginLeft: '20px',
            marginRight: '120px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px',
            marginRight: '10px'
        }
    })
}));

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
    const theme = useTheme();
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));

    // Handle tasks
    const [taskOpen, setTaskOpen] = useState(false);
    const menuBasis = useSelector((state) => state.customization.menuBasis);
    const menuBadge = useSelector((state) => state.customization.menuBadge);
    // Handle left drawer
    const isOpened = useSelector((state) => state.customization.opened);
    const leftDrawerOpened = isOpened == true || isOpened?.length > 0 ? true : false;
    const dispatch = useDispatch();
    const handleLeftDrawerToggle = () => {
        dispatch({ type: SET_MENU, opened: !leftDrawerOpened });
    };

    const polling = {
        enabled: true,
        url: `${ApiUrl}/api/online`,
        timeout: 3000,
        interval: 5000
    };

    const handleTaskToggle = () => {
        setTaskOpen(!taskOpen);
    };

    useEffect(() => {
        const href = location.href;
        dispatch({ type: SET_MENU, opened: !matchDownMd && href?.match(/(basis)/) && !href?.match(/(print|designer)/) });
        if (!href?.match(/(basis)/)) setTaskOpen(false);
    }, [location.href, matchDownMd]);

    useEffect(() => {
        const task = JSON.parse(localStorage.getItem('task') || '{}');
        if (menuBadge?.taskTime > task?.time) {
            setTaskOpen(true);
            localStorage.setItem('task', JSON.stringify({ time: new Date().valueOf() }));
        }
    }, [menuBadge?.task]);

    return (
        <Box sx={{ display: 'flex', background: theme.palette.background.light, justifyContent: 'center' }}>
            <CssBaseline />

            {/*
            <Toolbar sx={{ alignItems: 'start' }}>
                <ButtonBase
                    sx={{ borderRadius: '12px', overflow: 'hidden', mt: { xs: 3.75, md: 4 }, mr: '100px', ml: '-100px', zIndex: 9999 }}
                >
                    <Avatar
                        variant="rounded"
                        sx={{
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.secondary.light,
                            color: theme.palette.secondary.dark,
                            '&:hover': {
                                background: theme.palette.secondary.dark,
                                color: theme.palette.secondary.light
                            }
                        }}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem" />
                    </Avatar>
                </ButtonBase>
            </Toolbar>
            */}

            {/* Tasks */}
            <Snackbar open={taskOpen} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={99999999}>
                <div>
                    <Alert severity="error" variant="filled" sx={{ position: 'relative', minWidth: '380px' }} onClose={handleTaskToggle}>
                        {menuBadge?.task} وظیفه‌ی محول شده دارید!
                        <Button
                            href={`/#/basis/${menuBasis}/tasks`}
                            onClick={handleTaskToggle}
                            sx={{ height: 0, color: theme.palette?.success.light }}
                        >
                            مشاهده
                        </Button>
                    </Alert>
                </div>
            </Snackbar>

            {/* drawer */}
            <Sidebar drawerOpen={leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} />

            {/* main content */}
            <Main theme={theme} open={leftDrawerOpened}>
                {/* breadcrumb */}
                <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title leftAlign />
                <CurrencyProvider>
                    <Outlet />
                </CurrencyProvider>
                {/*
                <Online polling={polling}>
                    <CurrencyProvider>
                        <Outlet />
                    </CurrencyProvider>
                </Online>
                <Offline polling={polling}>
                    <SnackAlert message="عـدم برقــراری ارتبـاط با ســرور!" type="error" hideDuration={999999999} />
                    <Social />
                </Offline>
                */}
            </Main>
            {/*
            <Customization />
             */}
        </Box>
    );
};

export default MainLayout;
